import { Link } from "react-router-dom";

const TABS = [
  { key: "leads", label: "Leads", to: "/admin/leads" },
  { key: "products", label: "Products", to: "/admin/products" },
  { key: "collections", label: "Collections", to: "/admin/collections" },
  { key: "articles", label: "Articles", to: "/admin/articles" },
  { key: "landing-pages", label: "Landing Pages", to: "/admin/landing-pages" },
  { key: "site-content", label: "Site Content", to: "/admin/site-content" },
  { key: "green-gift-projects", label: "Green Gift Projects", to: "/admin/green-gift-projects" },
  { key: "partner-brands", label: "Partner Brands", to: "/admin/partner-brands" },
];

export default function AdminHeader({ active, email, onLogout }) {
  return (
    <header className="admin-nav">
      <div className="admin-nav-left">
        <a href="/" className="nav-logo" aria-label="Utsah — home">utsah</a>
        <span className="admin-nav-tag">Admin</span>
        <nav className="admin-tabs" aria-label="Admin sections">
          {TABS.map((t) => (
            <Link
              key={t.key}
              to={t.to}
              className={`admin-tab ${active === t.key ? "active" : ""}`.trim()}
              data-testid={`admin-tab-${t.key}`}
            >
              {t.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="admin-nav-right">
        <span className="admin-user" data-testid="admin-user-email">{email}</span>
        <button className="admin-nav-btn" onClick={onLogout} data-testid="admin-logout-btn">Sign out</button>
      </div>
    </header>
  );
}
